module.exports = __webpack_public_path__ + "media/images/menu-icon-fe837e6e62fb112b0308d688f9e29c0e.png";